export enum PlatformEnum {
  WEB = 'WEB',
  IOS = 'IOS',
  ANDROID = 'ANDROID',
}
